<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Logos - Change Order</div>
                  <p>You can change list ordering by drag and drop !</p>
                </div>
              <div class="col-md-2 offset-md-3 text-right center">
                <router-link to="/admin/logos" class="btn btn-primary" role="button">
                  back
                </router-link>
              </div>
            </div>

          <div class="table-responsive text-center">
            <div class="col-4" v-if="pages.length">
              <fg-select
                v-model="pageName"
                label="Page"
                :list="pages"
                selectedKey="id"
              >
              </fg-select>
            </div><br>
            <table class="table table-light table-bordered table-hover">
              <draggable v-model="filteredData" @start="drag=true" @end="drag=false">
                <tr v-for="(item, index) in filteredData" :key="index">
                  <td>{{item.logoId}}</td>
                  <td>{{item.pageName}}</td>
                  <td>{{item.siteNameText}}</td>
                  <td  style="word-wrap: break-word">{{item.linkDestination}}</td>
                  <td  style="word-wrap: break-word">{{item.logoUrl}}</td>
                  <td><img :src="item.logoUrl" alt="expert-image" class="table-thumbnail"></td>
                  <td>
                    <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                    <span class="badge badge-danger" v-else> Inactive </span>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>

          <div class="offset-md-3 col-md-6 text-center">
            <button class="btn btn-primary btn-fill btn-block" @click="updateLogosListing">
              Update listings order
            </button>
          </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import draggable from 'vuedraggable'
    const logoColumns = ['Id', 'Page', 'Site', 'Site URL', 'Logo URL', 'Image', 'Status'];
    export default {
        name: 'LogosSort',
        components: {
            LTable,
            draggable,
        },
        data() {
        return {
          filteredData: [],
          pages: [{id:"B2B", name:'B2B'}, {id:"UNAUTH", name:'UNAUTH'}],
          pageName: 'UNAUTH',
            logos: {
        data: []
        }
      }
    },
      watch: {
          'pageName' (to, from) {
            if (this.logos.data && this.logos.data.length > 0) {
              this.filteredData = this.logos.data.filter (x => {
                return x.pageName.toLowerCase() === this.pageName.toString().toLowerCase()
              })
            } else {
              this.filteredData = []
            }
          }
      },
    methods: {
      updateLogosListing () {
          let data = this.filteredData;
          let logoIds = data.map((obj) => {
            return obj.logoId
          });
          this.$store.dispatch('UPDATE_LOGOS_ORDERING', {dispOrderLogosIds: logoIds, pageName: this.pageName})
            .then((res) => {
              console.log("UPDATE_LOGOS_ORDERING API res : ", res);
              this.$swal('Success!', 'Display order updated successfully', 'success');
              this.$router.push('/admin/logos')
            })
            .catch(err => {
              console.log("UPDATE_LOGOS_ORDERING API error : ", err);
            })
        },
        fetchLogos () {
            this.$store.dispatch('FETCH_LOGOS')
                    .then((res) => {
                        this.logos.data = res;
                        this.filteredData = res.filter (x => {
                          return x.pageName.toLowerCase() === this.pageName.toLowerCase()
                        })
                        console.log(res)
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        }
    },
    created() {
        this.fetchLogos();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logos/OrderLogos.vue